import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row mb-20" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col span-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_LabeledSelect = _resolveComponent("LabeledSelect")!
  const _component_ResourceLabeledSelect = _resolveComponent("ResourceLabeledSelect")!
  const _component_NodeAffinity = _resolveComponent("NodeAffinity")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_RadioGroup, {
        value: $data.selectNode,
        "onUpdate:value": [
          _cache[0] || (_cache[0] = ($event: any) => (($data.selectNode) = $event)),
          $options.update
        ],
        name: "selectNode",
        options: $options.selectNodeOptions,
        mode: $props.mode,
        "data-testid": 'node-scheduling-selectNode'
      }, null, 8, ["value", "options", "mode", "onUpdate:value"])
    ]),
    _cache[4] || (_cache[4] = _createTextVNode()),
    ($data.selectNode === 'nodeSelector')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            ($props.nodes)
              ? (_openBlock(), _createBlock(_component_LabeledSelect, {
                  key: 0,
                  value: $data.nodeName,
                  "onUpdate:value": [
                    _cache[1] || (_cache[1] = ($event: any) => (($data.nodeName) = $event)),
                    $options.update
                  ],
                  label: _ctx.t('workload.scheduling.affinity.nodeName'),
                  options: $props.nodes || [],
                  mode: $props.mode,
                  multiple: false,
                  loading: $props.loading,
                  "data-testid": 'node-scheduling-nodeSelector'
                }, null, 8, ["value", "label", "options", "mode", "loading", "onUpdate:value"]))
              : (_openBlock(), _createBlock(_component_ResourceLabeledSelect, {
                  key: 1,
                  value: $data.nodeName,
                  "onUpdate:value": [
                    _cache[2] || (_cache[2] = ($event: any) => (($data.nodeName) = $event)),
                    $options.update
                  ],
                  label: _ctx.t('workload.scheduling.affinity.nodeName'),
                  "resource-type": $data.NODE,
                  mode: $props.mode,
                  multiple: false,
                  loading: $props.loading,
                  "data-testid": 'node-scheduling-nodeSelector',
                  allResourcesSettings: $data.nodeSchedulingAllSettings,
                  paginatedResourceSettings: $data.nodeSchedulingPaginationSettings
                }, null, 8, ["value", "label", "resource-type", "mode", "loading", "allResourcesSettings", "paginatedResourceSettings", "onUpdate:value"]))
          ])
        ]))
      : ($data.selectNode === 'affinity')
        ? (_openBlock(), _createBlock(_component_NodeAffinity, {
            key: 1,
            value: $data.nodeAffinity,
            "onUpdate:value": [
              _cache[3] || (_cache[3] = ($event: any) => (($data.nodeAffinity) = $event)),
              $options.update
            ],
            mode: $props.mode,
            "data-testid": 'node-scheduling-nodeAffinity'
          }, null, 8, ["value", "mode", "onUpdate:value"]))
        : _createCommentVNode("", true)
  ]))
}